import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {PatchAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class ForwardMessageByIdCommand<T> extends PatchAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: string) {
    super(
      apiService,
      adapter,
      `${environment.chatApiUrl}/messages/${id}/forward`,
    );
  }
}
